import request from '../index';

export async function getVersion(): Promise<string> {
  const result = await request({ url: '/versionz' });
  return result.data;
}
